import { Controller } from "stimulus"

export default class extends Controller {
  static targets = ["goalSummary"]

  static values = {
    url: String,
  }
  update() {
    const url = new URL(this.urlValue, window.location)
    const formData = new FormData(this.element)
    const unnecessary_fields = ["authenticity_token", "goal[title]", "goal[description]"]
    unnecessary_fields.forEach((field_name) => formData.delete(field_name))
    const params = new URLSearchParams(formData)
    const full_path = [url, params.toString()].join("?")
    fetch(full_path)
      .then((resp) => resp.text())
      .then((html) => {
        var parser = new DOMParser()
        var doc = parser.parseFromString(html, "text/html")
        const newSummary = doc.getElementById("goal-summary")
        const summary = this.goalSummaryTarget
        summary.innerHTML = newSummary.innerHTML
      })
  }
}
